export default __webpack_public_path__ + "static/media/awesome.15c7091f.png";